import { MapPin } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { CITIES } from "@/constants/site";

const AreaCities = ({ full = false }) => (
  <section className="bg-charcoal py-20 sm:py-28 border-t border-white/10" data-testid="service-area-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <SectionHead
        dark
        eyebrow="Coverage Map"
        title="Proudly serving Tarrant County"
        sub="From downtown Fort Worth to the Grapevine lakefront — if you're in Tarrant County, you're in our zone."
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {CITIES.map((c, i) => (
          <Reveal key={c} delay={i * 0.04}>
            <div
              className="group flex items-center justify-between border border-white/10 bg-steel px-5 py-4 transition-all duration-300 hover:border-dispatch hover:-translate-y-0.5"
              data-testid={`city-chip-${c.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <span className="flex items-center gap-2.5">
                <MapPin className="h-4 w-4 text-dispatch shrink-0" />
                <span className="font-display text-base sm:text-lg font-bold uppercase text-white">{c}</span>
              </span>
              <span className="hidden sm:block font-mono text-[10px] tracking-wider text-zinc-500 uppercase group-hover:text-dispatch transition-colors">
                ETA ~18m
              </span>
            </div>
          </Reveal>
        ))}
      </div>
      {full && (
        <Reveal delay={0.2}>
          <p className="mt-10 border-l-2 border-emergency pl-5 text-sm text-zinc-400 max-w-2xl">
            Don't see your city? We cover every mile of Tarrant County and surrounding corridors along I-35W,
            I-30, I-20, and TX-121. Text us your location and we'll confirm an ETA instantly.
          </p>
        </Reveal>
      )}
    </div>
  </section>
);

export default AreaCities;
